import React, {ReactElement} from 'react';
import {CanonicalUrl, PageDesc, PageTitle} from '../../const/seo';
import {Helmet} from 'react-helmet-async';
import Header from '../../components/page/header/header';
import Footer from '../../components/page/footer/footer';
import ModalContainer from '../../components/page/modal-container/modal-container';
import Blog from '../../components/blog/blog';

export default function BlogScreen(): ReactElement {
  return (
    <>
      <Helmet>
        <title>{PageTitle.Blog}</title>
        <meta name="description" content={PageDesc.Blog}></meta>
        <link rel="canonical" href={CanonicalUrl.Blog}/>
      </Helmet>
      <Header />
      <Blog/>
      <Footer />
      <ModalContainer />
    </>
  );
}
